import { render, staticRenderFns } from "./signSuccessMessage.vue?vue&type=template&id=1148f842"
import script from "./signSuccessMessage.vue?vue&type=script&lang=js"
export * from "./signSuccessMessage.vue?vue&type=script&lang=js"
import style0 from "./signSuccessMessage.vue?vue&type=style&index=0&id=1148f842&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports